module.exports = __webpack_public_path__ + "img/icon-quac.6fcc4dae.svg";